var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex"},[_c('MedicationTable',{attrs:{"selectedOptions":this.selectedBloodthinnerOptions,"question":_vm.question},on:{"setAnswer":(value) => this.$emit('setAnswer', value)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }